module.exports = __webpack_public_path__ + "img/show-qr-code.6c39aabe.svg";